export default __webpack_public_path__ + "static/media/thunderkick.f1f82c55.svg";